import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { GatewayDashboardSections } from '../../_models';
import { StorageService } from '../../_services';
import { GatewayDashboardFilters, GatewayTransactionType } from './gateway-summary';

@Component({
  selector: 'app-gateway-dashboard',
  templateUrl: './gateway-dashboard.component.html',
  styleUrls: ['./gateway-dashboard.component.scss'],
})
export class GatewayDashboardComponent implements OnInit, OnDestroy {
  sections = GatewayDashboardSections;
  selectedSection: GatewayDashboardSections = GatewayDashboardSections.TransactionSummary;

  filters: GatewayDashboardFilters = {
    start_date: moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_date: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    compare_start_date: moment().subtract(14, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    compare_end_date: moment().subtract(8, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  };

  // Populated from API once available
  merchantOptions: { id: string | number; name: string }[] = [];
  transactionTypeOptions: { value: GatewayTransactionType; label: string }[] = [
    { value: GatewayTransactionType.Initial,  label: 'Initial Orders' },
    { value: GatewayTransactionType.Rebill,   label: 'Rebills' },
    { value: GatewayTransactionType.OneTime,  label: 'One-Time Orders' },
  ];

  protected _destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private storageService: StorageService) {}

  ngOnInit() {}

  onSectionChange(section: GatewayDashboardSections) {
    if (section !== this.selectedSection) {
      this.selectedSection = section;
      if (section === GatewayDashboardSections.ApprovalAnalytics) {
        const updatedFilters = { ...this.filters };
        delete updatedFilters.campaign_id;
        delete updatedFilters.count_type;
        this.filters = updatedFilters;
      }
    }
  }

  onMerchantChange(merchantId: string | number) {
    this.filters = { ...this.filters, merchant_id: merchantId };
  }

  onOrderTypeChange(transactionType: GatewayTransactionType) {
    this.filters = { ...this.filters, order_type: transactionType };
  }

  onGatewayApply(dateFilters: { start_date: string; end_date: string; compare_start_date?: string; compare_end_date?: string }) {
    this.filters = { ...this.filters, ...dateFilters };
  }

  onReportNavigate(dimension: string) {
    this.storageService.set('gateway_dashboard_nav_filters', {
      start_date: this.filters.start_date,
      end_date: this.filters.end_date,
      compare_start_date: this.filters.compare_start_date,
      compare_end_date: this.filters.compare_end_date,
      merchant_id: this.filters.merchant_id,
      campaign_id: this.filters.campaign_id,
      order_type: this.filters.order_type,
      count_type: this.filters.count_type,
    });
    window.open('/gateway-performance-report-v3/dim/' + dimension, '_blank');
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
  }
}
